import classNames from "classnames"
import "./Container.scss"

const Container = ({ children, className }) => {
  return (
    <div
      className={classNames("landing-container", { [className]: className })}
    >
      {children}
    </div>
  )
}

export default Container
